'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--DribbbleWithCircle';

var EntypoDribbbleWithCircle = function EntypoDribbbleWithCircle(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10.26,9.982c0.033-0.012,0.068-0.021,0.103-0.031c-0.083-0.185-0.175-0.377-0.279-0.584c-1.88,0.557-3.68,0.562-4.001,0.557C6.08,9.949,6.08,9.975,6.08,10c0,0.945,0.34,1.853,0.958,2.566C7.244,12.234,8.336,10.605,10.26,9.982z M7.623,13.113C8.312,13.641,9.135,13.92,10,13.92c0.517,0,1.019-0.1,1.494-0.295c-0.066-0.381-0.295-1.541-0.822-2.922C8.551,11.453,7.75,12.865,7.623,13.113z M12.555,7.027C11.844,6.416,10.938,6.08,10,6.08c-0.284,0-0.569,0.031-0.85,0.094c0.205,0.275,0.832,1.146,1.421,2.223C11.854,7.904,12.434,7.193,12.555,7.027z M9.705,8.664C9.097,7.592,8.464,6.709,8.29,6.473C7.223,6.99,6.438,7.979,6.177,9.131h0.017C6.6,9.131,8.043,9.098,9.705,8.664z M11.514,10.496c0.465,1.293,0.679,2.367,0.74,2.711c0.852-0.6,1.434-1.521,1.609-2.543c-0.174-0.053-0.802-0.221-1.592-0.221C12.013,10.443,11.758,10.461,11.514,10.496z M10,0.4c-5.302,0-9.6,4.298-9.6,9.6s4.298,9.6,9.6,9.6s9.6-4.298,9.6-9.6S15.302,0.4,10,0.4z M10,14.697c-2.592,0-4.699-2.107-4.699-4.697c0-2.592,2.107-4.699,4.699-4.699c2.591,0,4.698,2.108,4.698,4.699C14.698,12.59,12.591,14.697,10,14.697z M10.922,9.074c0.087,0.18,0.168,0.357,0.242,0.531c0.023,0.057,0.048,0.113,0.071,0.17c0.277-0.033,0.573-0.049,0.882-0.049c0.854,0,1.563,0.125,1.801,0.172c-0.022-0.85-0.323-1.676-0.852-2.34C12.906,7.764,12.248,8.521,10.922,9.074z' })
    );
};

exports.default = EntypoDribbbleWithCircle;
module.exports = exports['default'];